import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.crawl');
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-crawl',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.crawl/view.scss */
:host {
  display: block;
  min-height: 100%;
  --crawl-bg: #f5f7f4;
  --crawl-surface: #ffffff;
  --crawl-surface-soft: #fbfcfa;
  --crawl-border: #dfe3db;
  --crawl-border-soft: #e8ebe5;
  --crawl-text: #17202a;
  --crawl-muted: #657069;
  --crawl-primary: #10375c;
  --crawl-primary-dark: #0b2947;
  --crawl-accent: #b28921;
  --crawl-accent-soft: #fff6df;
  background: #f5f7f4;
  color: #17202a;
}

.page-wrap {
  max-width: 1360px;
  margin: 0 auto;
  padding: 34px 28px 72px;
}

.work-header,
.control-panel,
.run-panel,
.progress-panel,
.results-panel,
.chat-panel {
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: var(--crawl-surface);
  box-shadow: 0 14px 34px rgba(23, 32, 42, 0.055);
}

.work-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 28px;
}

.header-copy h1 {
  margin: 6px 0 8px;
  font-size: 30px;
  font-weight: 850;
  letter-spacing: 0;
}

.header-copy p {
  margin: 0;
  max-width: 680px;
  color: #657069;
  line-height: 1.65;
}

.eyebrow,
.section-kicker {
  color: #b28921;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.mini-stat {
  min-width: 116px;
  padding: 12px 14px;
  border: 1px solid var(--crawl-border);
  border-radius: 8px;
  background: var(--crawl-surface-soft);
}

.mini-stat span {
  display: block;
  color: #78827c;
  font-size: 12px;
  font-weight: 800;
}

.mini-stat strong {
  display: block;
  margin-top: 4px;
  color: #10375c;
  font-size: 23px;
  font-weight: 850;
}

.crawl-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 16px;
  margin-top: 18px;
  align-items: start;
}

.results-column {
  min-width: 0;
}

.collector-sidebar {
  display: grid;
  align-content: start;
  gap: 16px;
  min-width: 0;
}

.collector-sidebar .control-panel,
.collector-sidebar .run-panel,
.collector-sidebar .progress-panel {
  min-width: 0;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px;
  border-bottom: 1px solid var(--crawl-border-soft);
  background: var(--crawl-surface-soft);
}

.panel-title h2 {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 850;
}

.panel-tools,
.panel-meta {
  display: flex;
  gap: 8px;
  align-items: center;
  color: #69746d;
  font-size: 13px;
  font-weight: 800;
}

button {
  font: inherit;
}

.text-btn,
.secondary-btn,
.primary-btn,
.run-btn,
.page-btn,
.bookmark-btn,
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.16s ease;
  white-space: nowrap;
}

.text-btn {
  border: 0;
  background: transparent;
  color: var(--crawl-primary);
  font-size: 13px;
  font-weight: 850;
}

.secondary-btn,
.primary-btn {
  min-height: 42px;
  padding: 0 15px;
  border: 1px solid var(--crawl-border);
  background: var(--crawl-surface);
  color: #26313d;
  font-weight: 850;
  flex: 0 0 auto;
}

.primary-btn,
.run-btn {
  border-color: var(--crawl-primary);
  background: var(--crawl-primary);
  color: #ffffff;
}

.primary-btn:hover,
.run-btn:hover {
  border-color: var(--crawl-primary-dark);
  background: var(--crawl-primary-dark);
}

.secondary-btn:hover,
.page-btn:hover {
  border-color: var(--crawl-primary);
  color: var(--crawl-primary);
}

.primary-btn:disabled,
.run-btn:disabled,
.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.keyword-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 22px;
}

.keyword-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid var(--crawl-border);
  border-radius: 999px;
  background: var(--crawl-surface);
  color: #4b5650;
  font-size: 13px;
  font-weight: 850;
  cursor: pointer;
}

.keyword-chip.is-selected {
  border-color: var(--crawl-primary);
  background: #edf3f8;
  color: var(--crawl-primary);
}

.keyword-chip i {
  color: #9aa39c;
  font-size: 11px;
}

.add-keyword {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 0 22px 22px;
}

.add-keyword .secondary-btn {
  min-width: 88px;
}

.add-keyword input,
.number-field input,
.chat-input textarea {
  width: 100%;
  border: 1px solid var(--crawl-border);
  border-radius: 8px;
  background: var(--crawl-surface);
  outline: none;
}

.add-keyword input {
  height: 42px;
  padding: 0 13px;
}

.add-keyword input:focus,
.number-field input:focus,
.chat-input textarea:focus {
  border-color: var(--crawl-primary);
  box-shadow: 0 0 0 3px rgba(16, 55, 92, 0.08);
}

.run-panel {
  display: flex;
  flex-direction: column;
}

.run-options {
  display: grid;
  gap: 16px;
  padding: 22px;
}

.number-field {
  display: grid;
  gap: 8px;
  color: #2b3440;
  font-size: 13px;
  font-weight: 850;
}

.number-field input {
  height: 44px;
  padding: 0 13px;
}

.run-note {
  display: flex;
  gap: 9px;
  padding: 12px;
  border-radius: 8px;
  background: var(--crawl-surface-soft);
  color: #626d67;
  font-size: 13px;
  line-height: 1.5;
}

.run-btn {
  margin: auto 22px 22px;
  min-height: 48px;
  border: 1px solid var(--crawl-primary);
  font-weight: 850;
}

.progress-panel,
.results-panel {
  overflow: hidden;
}

.collector-sidebar .progress-summary {
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
}

.collector-sidebar .progress-count {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  text-align: left;
}

.collector-sidebar .log-row {
  grid-template-columns: auto 1fr;
}

.collector-sidebar .log-row time {
  grid-column: 2;
  margin-top: -4px;
}

.progress-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px 12px;
}

.progress-title h2 {
  margin: 4px 0 0;
  font-size: 18px;
  font-weight: 850;
}

.progress-count {
  text-align: right;
}

.progress-count strong {
  display: block;
  color: #10375c;
  font-size: 22px;
  font-weight: 850;
}

.progress-count span {
  color: #76817b;
  font-size: 12px;
  font-weight: 800;
}

.progress-bar {
  height: 8px;
  margin: 0 22px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7ebe5;
}

.progress-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--crawl-primary);
  transition: width 0.25s ease;
}

.current-keyword {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 14px 22px 0;
  color: var(--crawl-primary);
  font-size: 13px;
  font-weight: 850;
}

.log-list {
  display: grid;
  gap: 8px;
  padding: 18px 22px 22px;
}

.log-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  background: var(--crawl-surface-soft);
  color: #5e6963;
  font-size: 13px;
}

.log-row i {
  color: #9aa39c;
  font-size: 8px;
}

.log-row time {
  color: #9aa39c;
  font-size: 12px;
}

.log-row.is-success {
  background: #edf8f1;
  color: #176a49;
}

.log-row.is-success i {
  color: #1d8f61;
}

.log-row.is-error {
  background: #fff2f0;
  color: #a43a31;
}

.log-row.is-error i {
  color: #d24c40;
}

.log-row.is-empty {
  background: #fff8e8;
  color: #8b650f;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  min-width: 1040px;
  border-collapse: collapse;
}

.data-table th {
  padding: 13px 18px;
  background: #f2f4f1;
  color: #657069;
  font-size: 12px;
  font-weight: 850;
  text-align: left;
}

.data-table td {
  padding: 16px 18px;
  border-top: 1px solid #edf0eb;
  vertical-align: middle;
}

.data-table tbody tr {
  cursor: pointer;
}

.data-table tbody tr:hover {
  background: #fbfcfa;
}

.title-cell {
  min-width: 360px;
}

.title-cell strong {
  display: block;
  color: #17202a;
  font-weight: 850;
  line-height: 1.45;
}

.title-cell span,
.date-text {
  display: block;
  margin-top: 4px;
  color: #88928c;
  font-size: 12px;
}

.budget,
.deadline {
  color: #10375c;
  font-weight: 850;
}

.keyword-pill {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--crawl-accent-soft);
  color: #8b650f;
  font-size: 12px;
  font-weight: 850;
}

.bookmark-btn {
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid var(--crawl-border);
  background: var(--crawl-surface);
  color: #4c5751;
  font-size: 13px;
  font-weight: 850;
}

.bookmark-btn.is-on {
  border-color: var(--crawl-primary);
  background: var(--crawl-primary);
  color: #fff;
}

.bookmark-btn:hover {
  border-color: var(--crawl-primary);
  color: var(--crawl-primary);
}

.bookmark-btn.is-on:hover {
  background: var(--crawl-primary-dark);
  color: #fff;
}

.loading-state,
.empty-state {
  display: grid;
  place-items: center;
  gap: 12px;
  min-height: 260px;
  padding: 36px;
  color: #717b75;
  text-align: center;
}

.empty-state i {
  color: #b7beb7;
  font-size: 34px;
}

.empty-state strong {
  color: #17202a;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
}

.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #dfe3db;
  border-top-color: #10375c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 18px 22px 22px;
  border-top: 1px solid #edf0eb;
}

.page-btn {
  min-width: 36px;
  height: 36px;
  border: 1px solid var(--crawl-border);
  background: var(--crawl-surface);
  color: #4d5751;
  font-weight: 850;
}

.page-btn.is-active {
  border-color: var(--crawl-primary);
  background: var(--crawl-primary);
  color: #fff;
}

.chat-fab {
  position: fixed;
  right: 26px;
  bottom: 26px;
  z-index: 40;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 0 16px;
  border: 1px solid var(--crawl-primary);
  border-radius: 999px;
  background: var(--crawl-primary);
  color: #fff;
  font-weight: 850;
  box-shadow: 0 14px 30px rgba(16, 55, 92, 0.24);
  cursor: pointer;
}

.chat-fab.is-open {
  background: var(--crawl-primary-dark);
  border-color: var(--crawl-primary-dark);
}

.chat-panel {
  position: fixed;
  right: 26px;
  bottom: 86px;
  z-index: 41;
  display: flex;
  flex-direction: column;
  width: min(420px, 100vw - 32px);
  height: min(620px, 100vh - 120px);
  overflow: hidden;
}

.chat-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--crawl-border-soft);
  background: var(--crawl-surface-soft);
}

.chat-title strong,
.chat-title span {
  display: block;
}

.chat-title span {
  margin-top: 2px;
  color: #7a847e;
  font-size: 12px;
}

.chat-actions {
  display: flex;
  gap: 6px;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border: 1px solid var(--crawl-border);
  background: var(--crawl-surface);
  color: #68736d;
}

.chat-body {
  flex: 1;
  display: grid;
  align-content: start;
  gap: 10px;
  padding: 16px;
  overflow-y: auto;
  background: var(--crawl-surface-soft);
}

.chat-message {
  display: flex;
  justify-content: flex-start;
}

.chat-message.is-user {
  justify-content: flex-end;
}

.bubble {
  max-width: 86%;
  padding: 10px 12px;
  border: 1px solid var(--crawl-border);
  border-radius: 8px;
  background: #fff;
  color: #26313d;
  font-size: 13px;
  line-height: 1.55;
}

.chat-message.is-user .bubble {
  border-color: var(--crawl-primary);
  background: var(--crawl-primary);
  color: #fff;
}

.chat-input {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--crawl-border-soft);
  background: var(--crawl-surface);
}

.chat-input textarea {
  min-height: 44px;
  max-height: 110px;
  padding: 11px 12px;
  resize: none;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
:host ::ng-deep .chat-md strong {
  font-weight: 850;
}

@media (max-width: 980px) {
  .page-wrap {
    padding: 20px 14px 72px;
  }
  .work-header,
  .progress-summary,
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions,
  .crawl-workspace {
    width: 100%;
    grid-template-columns: 1fr;
  }
  .mini-stat {
    flex: 1;
  }
  .add-keyword {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .chat-input {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .header-actions {
    flex-direction: column;
  }
  .add-keyword {
    grid-template-columns: 1fr;
  }
  .add-keyword .secondary-btn,
  .run-btn {
    width: 100%;
  }
}
/* Library-tone compact overrides */
:host {
  --crawl-bg: #fafafa;
  --crawl-surface: #ffffff;
  --crawl-surface-soft: #fafafa;
  --crawl-border: #e4e4e7;
  --crawl-border-soft: #f4f4f5;
  --crawl-text: #18181b;
  --crawl-muted: #71717a;
  --crawl-primary: #0f766e;
  --crawl-primary-dark: #0b5f59;
  --crawl-accent: #0f766e;
  --crawl-accent-soft: #ecfdf5;
  background: var(--crawl-bg);
  color: var(--crawl-text);
}

.page-wrap {
  max-width: 1560px;
  padding: 20px 24px 60px;
}

.work-header {
  align-items: flex-start;
  padding: 0 0 12px;
  margin-bottom: 16px;
  border: 0;
  border-bottom: 1px solid var(--crawl-border);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-copy {
  display: grid;
  gap: 3px;
}

.header-copy h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.header-copy p {
  max-width: none;
  font-size: 12px;
  line-height: 1.45;
  color: var(--crawl-muted);
}

.eyebrow,
.section-kicker {
  color: var(--crawl-primary);
  font-size: 11px;
  font-weight: 650;
  text-transform: none;
}

.mini-stat {
  min-width: auto;
  height: 28px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--crawl-border-soft);
}

.mini-stat span,
.mini-stat strong {
  display: inline;
  margin: 0;
  font-size: 11px;
  line-height: 1;
}

.mini-stat strong {
  color: #52525b;
}

.crawl-workspace {
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 12px;
  margin-top: 0;
}

.collector-sidebar {
  gap: 12px;
}

.work-header,
.control-panel,
.run-panel,
.progress-panel,
.results-panel,
.chat-panel {
  box-shadow: none;
}

.control-panel,
.run-panel,
.progress-panel,
.results-panel,
.chat-panel {
  border-color: var(--crawl-border);
}

.panel-head {
  min-height: 48px;
  padding: 12px 14px;
  background: var(--crawl-surface);
}

.panel-title h2,
.progress-title h2 {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 700;
}

.text-btn,
.secondary-btn,
.primary-btn,
.run-btn,
.page-btn,
.bookmark-btn,
.icon-btn {
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.secondary-btn,
.primary-btn {
  min-height: 32px;
  height: 32px;
  padding: 0 12px;
}

.keyword-grid {
  gap: 6px;
  padding: 14px;
}

.keyword-chip {
  min-height: 30px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
}

.add-keyword {
  padding: 0 14px 14px;
}

.add-keyword input,
.number-field input {
  height: 32px;
  min-height: 32px;
  border-radius: 6px;
  font-size: 12px;
}

.run-options {
  gap: 10px;
  padding: 14px;
}

.number-field {
  font-size: 12px;
  font-weight: 600;
}

.run-note {
  padding: 9px 10px;
  border-radius: 6px;
  font-size: 11px;
}

.run-btn {
  min-height: 34px;
  margin: auto 14px 14px;
}

.progress-summary {
  padding: 14px 14px 10px;
}

.progress-count strong {
  font-size: 18px;
}

.progress-bar {
  height: 6px;
  margin: 0 14px;
}

.current-keyword {
  margin: 10px 14px 0;
  font-size: 12px;
}

.log-list {
  gap: 6px;
  padding: 12px 14px 14px;
}

.log-row {
  min-height: 32px;
  border-radius: 6px;
  font-size: 12px;
}

.data-table {
  min-width: 880px;
}

.data-table th {
  padding: 10px 14px;
  background: var(--crawl-surface-soft);
  font-size: 11px;
  font-weight: 650;
}

.data-table td {
  padding: 12px 14px;
}

.title-cell strong,
.budget,
.deadline {
  font-weight: 650;
}

.keyword-pill,
.bookmark-btn {
  min-height: 26px;
  font-size: 11px;
  font-weight: 600;
}

.loading-state,
.empty-state {
  min-height: 220px;
  padding: 42px 20px;
}

.empty-state i {
  font-size: 26px;
}

.empty-state strong {
  font-size: 13px;
  font-weight: 650;
}

.pagination {
  padding: 12px 14px 14px;
}

.page-btn {
  min-width: 30px;
  height: 30px;
}

.chat-fab {
  height: 40px;
  padding: 0 13px;
  box-shadow: 0 8px 18px rgba(15, 118, 110, 0.16);
}

.chat-head,
.chat-input {
  background: var(--crawl-surface);
}

.bubble {
  border-radius: 8px;
  font-size: 12px;
}

/* Font scale refinement */
.crawl-page {
  font-size: 12px;
}

.header-copy h1 {
  font-size: 16px;
}

.header-copy p,
.panel-tools,
.panel-meta,
.run-note,
.current-keyword,
.log-row,
.bubble {
  font-size: 11.5px;
}

.panel-title h2,
.progress-title h2 {
  font-size: 14px;
}

.keyword-chip,
.secondary-btn,
.primary-btn,
.run-btn,
.bookmark-btn {
  font-size: 11.5px;
}

.title-cell strong,
.budget,
.deadline {
  font-size: 12px;
}

.data-table td {
  font-size: 12px;
}

@media (max-width: 1160px) {
  .crawl-workspace {
    grid-template-columns: 1fr;
  }
  .collector-sidebar {
    grid-template-columns: minmax(0, 1fr) minmax(260px, 0.65fr);
  }
  .collector-sidebar .progress-panel {
    grid-column: 1/-1;
  }
}
@media (max-width: 720px) {
  .collector-sidebar {
    grid-template-columns: 1fr;
  }
  .collector-sidebar .progress-panel {
    grid-column: auto;
  }
}`],
})
export class PageCrawlComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public keywords: any[] = [];
    public defaultKeywords: any[] = [
        { label: '인공지능', selected: true },
        { label: 'AI', selected: true },
        { label: '챗봇', selected: true },
        { label: '생성형 AI', selected: true },
        { label: 'LLM', selected: true },
        { label: '대화형 AI', selected: false },
        { label: '챗GPT', selected: false },
        { label: 'RAG', selected: false },
        { label: 'AI 플랫폼', selected: false },
        { label: 'AI 도입', selected: false },
        { label: 'AI 구축', selected: false },
        { label: '업무자동화', selected: false }
    ];
    public newKeyword: string = '';
    public maxResults: number = 10;
    public results: any[] = [];
    public loading: boolean = false;
    public crawled: boolean = false;
    public totalCount: number = 0;
    public scrappedSet: Set<string> = new Set();

    // 결과 페이지네이션
    public page: number = 1;
    public pageSize: number = 10;

    // AI 챗봇
    public chatOpen: boolean = false;
    public chatMessages: any[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;

    public progress: any = {
        current: 0,
        total: 0,
        currentKeyword: '',
        logs: [],
        duplicateSkipped: 0
    };

    public async ngOnInit() {
        await this.service.init();
        await this.loadKeywords();
        this.restoreResults();
        await this.loadScrapped();
        await this.service.render();
    }

    private async loadKeywords() {
        try {
            let res = await wiz.call("load_keywords");
            if (res.code === 200 && res.data.keywords && res.data.keywords.length > 0) {
                if (this.shouldExpandDefaultKeywords(res.data.keywords)) {
                    let merged = this.mergeDefaultKeywords(res.data.keywords);
                    this.keywords = merged.keywords;
                    if (merged.changed) await this.saveKeywords();
                } else {
                    this.keywords = this.cleanKeywords(res.data.keywords);
                }
            } else {
                this.keywords = JSON.parse(JSON.stringify(this.defaultKeywords));
                await this.saveKeywords();
            }
        } catch {
            this.keywords = JSON.parse(JSON.stringify(this.defaultKeywords));
        }
    }

    private mergeDefaultKeywords(savedKeywords: any[]) {
        let keywords = this.cleanKeywords(savedKeywords);
        let existingLabels = new Set(keywords.map(k => this.normalizeKeyword(k.label)));
        let changed = keywords.length !== (savedKeywords || []).length;

        for (let keyword of this.defaultKeywords) {
            let label = keyword.label.trim();
            let normalized = this.normalizeKeyword(label);
            if (existingLabels.has(normalized)) continue;

            keywords.push({ label, selected: keyword.selected });
            existingLabels.add(normalized);
            changed = true;
        }

        return { keywords, changed };
    }

    private cleanKeywords(keywords: any[]) {
        return (keywords || [])
            .map(k => ({
                label: String(k?.label || '').trim(),
                selected: !(k?.selected === false || k?.selected === 0 || k?.selected === 'false')
            }))
            .filter(k => k.label);
    }

    private shouldExpandDefaultKeywords(savedKeywords: any[]) {
        let keywords = this.cleanKeywords(savedKeywords);
        if (keywords.length > 2) return false;
        return keywords.some(k => this.isAiSeedKeyword(k.label));
    }

    private isAiSeedKeyword(keyword: string) {
        let normalized = this.normalizeKeyword(keyword).replace(/\s+/g, '');
        return ['ai', '인공지능', '챗봇', '생성형ai', 'llm'].includes(normalized);
    }

    private normalizeKeyword(keyword: string) {
        return keyword.trim().toLowerCase();
    }

    private async saveKeywords() {
        try {
            await wiz.call("save_keywords", { keywords: JSON.stringify(this.keywords) });
        } catch { }
    }

    private restoreResults() {
        try {
            let stored = sessionStorage.getItem('crawl_results');
            if (stored) {
                let data = JSON.parse(stored);
                this.results = data.results || [];
                this.totalCount = data.totalCount || 0;
                this.crawled = this.results.length > 0;
                this.progress.logs = data.logs || [];
                this.page = 1;
            }
        } catch { }
    }

    // ── Pagination helpers ──
    public get totalPages(): number {
        if (this.results.length === 0) return 1;
        return Math.max(1, Math.ceil(this.results.length / this.pageSize));
    }
    public get pagedResults(): any[] {
        const start = (this.page - 1) * this.pageSize;
        return this.results.slice(start, start + this.pageSize);
    }
    public get pageStart(): number {
        if (this.results.length === 0) return 0;
        return (this.page - 1) * this.pageSize + 1;
    }
    public get pageEnd(): number {
        return Math.min(this.page * this.pageSize, this.results.length);
    }
    public get pageNumbers(): number[] {
        const total = this.totalPages;
        const cur = this.page;
        const max = 7;
        if (total <= max) return Array.from({ length: total }, (_, i) => i + 1);
        let start = Math.max(1, cur - 3);
        let end = Math.min(total, start + max - 1);
        start = Math.max(1, end - max + 1);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
    public async goToPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.service.render();
    }

    private saveResults() {
        try {
            sessionStorage.setItem('crawl_results', JSON.stringify({
                results: this.results,
                totalCount: this.totalCount,
                logs: this.progress.logs
            }));
        } catch { }
    }

    private async loadScrapped() {
        try {
            let res = await wiz.call("scrapped_ids");
            if (res.code === 200) {
                this.scrappedSet = new Set(res.data.ids || []);
            }
        } catch { }
    }

    public isScrapped(noticeNo: string): boolean {
        return this.scrappedSet.has(noticeNo);
    }

    public async toggleScrap(item: any, event: Event) {
        event.stopPropagation();
        let noticeNo = item.notice_no;
        if (this.isScrapped(noticeNo)) {
            let res = await wiz.call("unscrap", { notice_no: noticeNo });
            if (res.code === 200) this.scrappedSet.delete(noticeNo);
        } else {
            let res = await wiz.call("scrap", { data: JSON.stringify(item) });
            if (res.code === 200) this.scrappedSet.add(noticeNo);
        }
        await this.service.render();
    }

    public async toggleKeyword(kw: any) {
        kw.selected = !kw.selected;
        await this.saveKeywords();
        await this.service.render();
    }

    public async selectAll() {
        this.keywords.forEach(k => k.selected = true);
        await this.saveKeywords();
        await this.service.render();
    }

    public async deselectAll() {
        this.keywords.forEach(k => k.selected = false);
        await this.saveKeywords();
        await this.service.render();
    }

    public get selectedCount() {
        return this.keywords.filter(k => k.selected).length;
    }

    public get progressPercent() {
        if (this.progress.total === 0) return 0;
        return Math.round((this.progress.current / this.progress.total) * 100);
    }

    public async addKeyword(event?: KeyboardEvent) {
        if (event && event.isComposing) return;
        let kw = this.newKeyword.trim();
        if (!kw) return;
        if (this.keywords.find(k => this.normalizeKeyword(k.label) === this.normalizeKeyword(kw))) {
            await this.service.modal.show({
                title: '', message: '이미 등록된 키워드입니다.',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            return;
        }
        this.keywords.push({ label: kw, selected: true });
        this.newKeyword = '';
        await this.saveKeywords();
        await this.service.render();
    }

    public async removeKeyword(index: number) {
        this.keywords.splice(index, 1);
        await this.saveKeywords();
        await this.service.render();
    }

    public async startCrawl() {
        let selected = this.keywords.filter(k => k.selected).map(k => k.label);
        if (selected.length === 0) {
            await this.service.modal.show({
                title: '', message: '검색할 키워드를 1개 이상 선택해주세요.',
                cancel: false, action: '확인', actionBtn: 'error', status: 'error'
            });
            return;
        }

        this.loading = true;
        this.results = [];
        this.totalCount = 0;
        this.page = 1;
        this.progress = {
            current: 0,
            total: selected.length,
            currentKeyword: '',
            logs: [],
            duplicateSkipped: 0
        };
        await this.service.render();

        let seen = new Set<string>();

        // 키워드별 균등 분배: maxResults를 키워드 개수로 나눠 키워드당 fetch 상한 결정.
        // 중복 제외분 보충을 위해 약간의 버퍼를 둔다.
        const perKeywordFetch = Math.max(
            Math.ceil(this.maxResults / selected.length) + 2,
            5
        );

        for (let i = 0; i < selected.length; i++) {
            let keyword = selected[i];
            this.progress.current = i;
            this.progress.currentKeyword = keyword;
            this.addLog('search', `"${keyword}" 검색 중... (키워드당 최대 ${perKeywordFetch}건 조회)`);
            await this.service.render();

            try {
                const params = new URLSearchParams();
                params.set('keyword', keyword);
                params.set('maxResults', String(perKeywordFetch));

                const resp = await fetch(wiz.url('crawl_single'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    body: params.toString(),
                    credentials: 'same-origin'
                });

                let res: any = null;
                let raw = '';
                try {
                    raw = await resp.text();
                    res = raw ? JSON.parse(raw) : {};
                } catch {
                    throw new Error(raw.slice(0, 200) || `HTTP ${resp.status}`);
                }

                let code = res.code;
                let data = res.data;

                if (code === 200) {
                    let items = data.items || [];
                    let fetchedCount = data.totalCount || items.length || 0;
                    let expiredCount = data.expiredCount || 0;

                    let added = 0;
                    let skipped = 0;
                    for (let item of items) {
                        if (item.notice_no && !seen.has(item.notice_no)) {
                            seen.add(item.notice_no);
                            item.matched_keyword = keyword;
                            this.results.push(item);
                            added++;
                        } else {
                            skipped++;
                        }
                    }
                    this.totalCount = this.results.length;
                    this.progress.duplicateSkipped += skipped;

                    if (items.length === 0 && expiredCount === 0) {
                        this.addLog('empty', `"${keyword}" — 결과 없음`);
                    } else {
                        let extras = [];
                        if (expiredCount > 0) extras.push(`마감 ${expiredCount}건`);
                        if (skipped > 0) extras.push(`중복 ${skipped}건`);
                        let extraStr = extras.length > 0 ? `, ${extras.join(' · ')} 제외` : '';
                        this.addLog('success', `"${keyword}" — ${added}건 반영 (조회 ${fetchedCount}건${extraStr})`);
                    }
                } else {
                    this.addLog('error', `"${keyword}" — 오류: ${data?.message || '알 수 없는 오류'}`);
                }
            } catch (e: any) {
                this.addLog('error', `"${keyword}" — 요청 실패: ${e.message || e}`);
            }

            await this.service.render();
        }

        // 모든 키워드 수집 완료 후 maxResults 상한으로 트림
        let trimmed = 0;
        if (this.results.length > this.maxResults) {
            trimmed = this.results.length - this.maxResults;
            this.results = this.results.slice(0, this.maxResults);
            this.totalCount = this.results.length;
        }

        this.progress.current = selected.length;
        this.progress.currentKeyword = '';
        let dups = this.progress.duplicateSkipped > 0 ? ` (중복 ${this.progress.duplicateSkipped}건 제외)` : '';
        let trimNote = trimmed > 0 ? ` · 상한 ${this.maxResults}건 기준 ${trimmed}건 잘라냄` : '';
        this.addLog('done', `완료! 총 ${this.results.length}건 수집${dups}${trimNote}`);

        this.loading = false;
        this.crawled = true;
        this.page = 1;
        this.saveResults();
        await this.service.render();
    }

    public openDetail(item: any) {
        localStorage.setItem('crawl_notice', JSON.stringify(item));
        this.service.href(`/crawl/${item.notice_no}`);
    }

    public getDday(deadline: string): number | null {
        if (!deadline) return null;
        try {
            let dt: Date;
            if (deadline.includes('-')) {
                dt = new Date(deadline);
            } else if (deadline.length >= 8) {
                let y = deadline.substring(0, 4);
                let m = deadline.substring(4, 6);
                let d = deadline.substring(6, 8);
                dt = new Date(`${y}-${m}-${d}`);
            } else {
                return null;
            }
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            dt.setHours(0, 0, 0, 0);
            return Math.ceil((dt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        } catch {
            return null;
        }
    }

    public getDdayColor(days: number | null): string {
        if (days === null) return 'text-stone-400';
        if (days <= 3) return 'text-red-500';
        if (days <= 7) return 'text-orange-500';
        if (days <= 14) return 'text-yellow-600';
        return 'text-emerald-600';
    }

    public getDdayText(days: number | null): string {
        if (days === null) return '-';
        if (days === 0) return 'D-Day';
        if (days > 0) return `D-${days}`;
        return `D+${Math.abs(days)}`;
    }

    private addLog(type: string, message: string) {
        this.progress.logs.push({
            type: type,
            message: message,
            time: new Date().toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
        });
    }

    public formatBudget(amount: number) {
        if (!amount) return '-';
        if (amount >= 100000000) return (amount / 100000000).toFixed(1) + '억원';
        if (amount >= 10000) return (amount / 10000).toFixed(0) + '만원';
        return amount.toLocaleString() + '원';
    }

    public formatDate(dt: string) {
        if (!dt || dt.length < 8) return '-';
        if (dt.includes('-')) return dt.substring(0, 10);
        return dt.substring(0, 4) + '-' + dt.substring(4, 6) + '-' + dt.substring(6, 8);
    }

    // =================== AI 챗봇 ===================

    public async toggleChat() {
        this.chatOpen = !this.chatOpen;
        if (this.chatOpen && this.chatMessages.length === 0) {
            this.chatMessages.push({
                role: 'assistant',
                content: '안녕하세요! 수집된 공고를 분석하고 입찰 추천을 도와드리겠습니다.\n\n질문 예시:\n• "마감이 임박한 공고 추천해줘"\n• "예산 규모가 큰 공고는?"\n• "AI 관련 공고 중 유망한 것은?"\n• "이 공고들의 전체적인 특징을 분석해줘"'
            });
        }
        await this.service.render();
    }

    public async sendChat(event?: KeyboardEvent) {
        if (event && event.isComposing) return;
        let msg = this.chatInput.trim();
        if (!msg || this.chatLoading) return;

        this.chatMessages.push({ role: 'user', content: msg });
        this.chatInput = '';
        this.chatLoading = true;
        await this.service.render();

        try {
            let summaries = this.results.slice(0, 30).map((r, i) => ({
                no: i + 1,
                title: r.title,
                org: r.org_name,
                budget: r.budget,
                deadline: r.deadline,
                keyword: r.matched_keyword,
                dday: this.getDday(r.deadline)
            }));

            let res = await wiz.call("ai_chat", {
                message: msg,
                results: JSON.stringify(summaries),
                history: JSON.stringify(this.chatMessages.slice(-10).map(m => ({ role: m.role, content: m.content })))
            });

            if (res.code === 200) {
                this.chatMessages.push({ role: 'assistant', content: res.data.reply });
            } else {
                this.chatMessages.push({ role: 'assistant', content: `오류: ${res.data?.message || '응답을 받지 못했습니다. AI 설정에서 모델이 등록되어 있는지 확인해주세요.'}` });
            }
        } catch (e: any) {
            this.chatMessages.push({ role: 'assistant', content: '연결 오류가 발생했습니다. 잠시 후 다시 시도해주세요.' });
        }

        this.chatLoading = false;
        await this.service.render();
    }

    public async clearChat() {
        this.chatMessages = [{
            role: 'assistant',
            content: '대화가 초기화되었습니다. 무엇이든 질문해주세요!'
        }];
        await this.service.render();
    }

    public renderMarkdown(text: string): SafeHtml {
        if (!text) return '';
        let html = text
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/^### (.+)$/gm, '<div class="font-semibold text-stone-800 mt-2 mb-1">$1</div>')
            .replace(/^## (.+)$/gm, '<div class="font-semibold text-stone-900 text-[14px] mt-3 mb-1">$1</div>')
            .replace(/^# (.+)$/gm, '<div class="font-bold text-stone-900 text-[15px] mt-3 mb-1">$1</div>')
            .replace(/\*\*(.+?)\*\*/g, '<strong class="font-semibold text-stone-800">$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(/^- (.+)$/gm, '<div class="flex gap-1.5 ml-1"><span class="text-stone-400">•</span><span>$1</span></div>')
            .replace(/^(\d+)\. (.+)$/gm, '<div class="flex gap-1.5 ml-1"><span class="text-stone-500 font-medium">$1.</span><span>$2</span></div>')
            .replace(/`([^`]+)`/g, '<code class="bg-stone-200 text-stone-700 px-1 py-0.5 rounded text-[12px]">$1</code>')
            .replace(/\n\n/g, '<div class="h-2"></div>')
            .replace(/\n/g, '<br>');
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}

export default PageCrawlComponent;